import { useGLTF } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import { useEffect, useRef } from 'react';

import factory from '@/assets/models/factory.glb';

const Animator = ({ customMesh, meshRef, animationParam }) => {
	// this can expand to x start final, z start final
	// we can also add in rotation start and finish
	// or better yet just position & rotation start and end arrays
	// plus a speed value

	const { position_x_offset, position_y_start, position_y_final } =
		animationParam;

	// 🔥 THIS is the ONLY animated value
	const y = useRef(position_y_start);
	const velocity = useRef(0);
	const started = useRef(false);
	const speed = 4.2 * 0.25 * 0.25 * 0.25;

	// INIT ONLY ON FIRST MOUNT
	useEffect(() => {
		if (!meshRef.current) return;

		meshRef.current.position.set(position_x_offset, position_y_start, 0);
		y.current = position_y_start;

		if (!started.current) {
			started.current = true;
		}
	}, []);

	useFrame((_, delta) => {
		if (!meshRef.current) return;

		// simple gravity
		if (y.current < position_y_final) {
			velocity.current += speed * delta;
			y.current += velocity.current;

			if (y.current >= position_y_final) {
				y.current = position_y_final;
				velocity.current = 0;
			}
		} else {
			y.current = position_y_final;
		}

		meshRef.current.position.set(position_x_offset, y.current, 0);
	});

	return <>{customMesh}</>;
};

useGLTF.preload(factory);

export default Animator;
